import React, { useRef } from "react";
import { ImgBox1, TextBox1, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com1 = () => {
  const ref1 = useRef();

  useScrollFadeIn(ref1);
  return (
    <Wrapper>
      <TextBox1>
        <div>News & Event</div>
        <div>매주 업데이트되는 Sketch 최신 소식과 이벤트를 확인해 다양한 혜택을 누리세요.</div>
      </TextBox1>
      <ImgBox1 loading="lazy">
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/a44e896dNewsEvents_1.svg"
          alt="위에 메인 이미지"
          ref={ref1}
          className="fade-in"
        />
      </ImgBox1>
    </Wrapper>
  );
};

export default Com1;
